import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { RoleDetailSchema, RoleSchema } from "../../Schemas/Role";

interface Filter extends IFilterSchema {
  column: RolesListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: RolesListColumnSortable;
}

export enum RolesListColumnFilterable {
  ID = "id",
  CAPTION = "caption",
  CREATED_AT = "created_at",
}
export enum RolesListColumnSortable {
  ID = "id",
  CAPTION = "caption",
  CREATED_AT = "created_at",
}

interface ICreateRolePayload {
  caption: string;
  group: string;
  section_ids: number[];
  description: string;
}

export interface RolesListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface RolesListResponseBody extends IResponseBody {
  data: {
    acl_roles: RoleSchema[];
    total: number;
  };
}
export interface RoleCreateResponseBody extends IResponseBody {
  data: {
    acl_role: RoleSchema;
  };
}

export interface RolesDetailResponseBody extends IResponseBody {
  data: {
    acl_role: RoleDetailSchema;
  };
}

export class RolesListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/acl-roles`;
  }

  async send(
    queryStrings?: RolesListQueryString
  ): Promise<RolesListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async details(roleId: string): Promise<RolesDetailResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + `/${roleId}/details`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async create(payload: ICreateRolePayload): Promise<RoleCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/create`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async update(
    roleId: string,
    payload: ICreateRolePayload
  ): Promise<RoleCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/update`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
